export default {
  SIGN: {
    WIDGET_INIT_ERR: 'Error initializing the widget',
    WIDGET_CONFIG_ERR: 'Widget configuration is not available',
    INVALID_ACCESS_TOKEN: 'Error initializing the widget: invalid token',
    AUTH_PROVIDER_ERR: 'Could not authenticate with provider ',
    ONCHAIN_CONFIG_NOT_FOUND_ERR: 'No on-chain config found, proceeding with offchain verification',
    SESSION_NOT_FOUND_ERR: 'Session not found, proceeding to generate one',
    SESSION_ID_INVALID: 'Session ID is invalid or missing, close this window and try again from service provider app',
    TOKEN_EXPIRED: 'Access Token Expired, please contact the admin',
    USER_NOT_AUTHORIZED: 'User not authorised to access the widget',
    WIDGET_READY_TO_USE: 'Widget is ready to use',
  },
  AUTH: {
    KYC_AUTH_FAILED: 'Authentication failed',
    KYC_TOKEN_MISSING: 'KYC service access token not found in response',
    KYC_NO_RESPONSE: 'No response from KYC service',
    REGISTRATION_FAILED: 'User registration failed',
    AUTH_ERROR: 'Authentication error occurred',
    GENERAL_ERROR: 'An error occurred. Please try again.',
  },
  LIVELINESS: {
    VERIFYING_SELFI: 'Verifying your selfie...',
    VERIFICATION_CLOSED_EYES: 'The person has their eyes closed',
    VERIFICATION_FAILED: 'Failed to verify the liveness check',
  },
  IDDOCUMENT: {
    VERIFYING_ID: 'Uploading your document and extracting data...',
    DOC_EXTRACTION_FINISED: 'Document extraction complete',
    VERIFICATION_FAILED: 'Failed to verify ID document',
    EXTRACTION_FAILED: 'Failed to extract document data',
    MISSING_ID_CAPTURE: 'User has not performed ID capturing',
    MISSING_FACIAL_RECOGNITION: 'User has not performed facial recognition',
    NO_COUNTRIES_FOUND: 'No countries found',
    JURISDICTION_COUNTRY_LIST_LIMITED: 'Some countries are unavailable due to jurisdiction restrictions.',
    JURISDICTION_COUNTRY_UNAVAILABLE: 'This country is not available for verification due to jurisdiction restrictions.',
  },
  USER_CONSENT: {
    DATA_SUBMIT: 'Submitting your data...',
    NO_CONSENT: 'No user consent found',
    VERIFICATION_FAILED: 'Failed to verify the user consent',
  },
  WALLET: {
    ECO_SYSTEM_NOT_SUPPORTED: 'Ecosystem or blockchain is not supported',
    CHAIN_NOT_SUPPORTED: 'Chain not supported for chainId requestedChainId ',
  },
  ON_CHAIN: {
    INVALID_CONFIG_ERR: 'Invalid configuration, please reload the widget and try again',
    IDENTITY_SUCCESS: 'Successfully minted your identity',
    SBT_MINT_FAILED: 'Failed to verify the SBT mint result',
    ASSET_CREATION_FAILED: 'Error in creating asset metadata',
  },
  VAULT: {
    SETUP_BUTTON: 'SETUP VAULT',
    SETUP: 'The PIN secures your data vault, ensuring that no one else, including us, can access your data. You own your data! The PIN will be needed to access your encrypted data vault, so please keep it safe.',
    SETUP_CONFIRMATION_POPUP_TITLE: 'Setup Vault Confirmation!',
    SETUP_CONFIRMATION_POPUP: 'The PIN secures your data vault, ensuring that no one else, including us, can access your data. You own your data! The PIN will be needed to access your encrypted data vault, so please keep it safe.',
    PIN_MISMATCHED: 'PINs did not match. Please re-enter them.',
    NO_PIN_ENTERED: 'Please enter your PIN to proceed',
    PASSCODE_REQUIREMENT_NOT_MATCHED: 'Passcode does not meet security requirements',
    CREDENTIALS_UPDATE_FAILED: 'Failed to update vault credentials',
    NO_CREDENTIAL_PAYLOAD: 'No credential payload provided',
    PIN_NOT_SET: 'Vault PIN not set. Please unlock the vault first.',
    UNLOCK_FAILED: 'Error: Could not unlock vault, please check your PIN',
  },
  ZK_PROOF: {
    VERIFICATION_FAILED: 'Failed to verify zero-knowledge proof',
  },
  OTHERS: {
    SESSION_EXPIRED: 'Session expired',
    CONTACT_SUPPORT: 'Please try again or contact support.',
  },
  MOBILE_FLOW: {
    UNAVAILABLE: 'This mobile verification link has expired or is no longer available.',
    ALREADY_USED: 'This QR code has already been used.',
    RESTART: 'Return to the verifier application and restart the KYC process to generate a new QR code.',
    BACK_TO_VERIFIER: 'Back To Verifier App',
  },
}
